import { Component, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { AuthenticationService, Logger } from "@app/core";
import { BaseControl, ConfirmComponent, Const, SeriePredeterminada } from "@app/shared/index";
import { LocalDataSource } from "ng2-smart-table";
import { ToastrService } from "ngx-toastr";
import { ConsecutiveManagementConfigService } from "./shared/consecutive-management-config.service";
import { ConsecutiveManagementFormService } from "./shared/consecutive-management-form.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import {
  Consecutive,
  ConsecutiveManagementDataService,
  Detalles,
  Documental,
} from "./shared/consecutive-management-component.data.service";
import { parseDate } from "ngx-bootstrap/chronos";
import { find } from "lodash";

const log = new Logger("ConsecutiveManagementComponent");

@Component({
  selector: "iw-consecutive-management",
  templateUrl: "./consecutive-management.component.html",
  styleUrls: ["./consecutive-management.component.scss"],
  providers: [ConsecutiveManagementFormService, ConsecutiveManagementDataService],
})
export class ConsecutiveManagementComponent implements OnInit {
  // se utiliza para setear los datos en formato de la libreria de la tabla
  // para poder realizar el filtro general
  source: LocalDataSource;
  sourceModal: LocalDataSource;
  // variable donde se configura las opciones de la tabla
  settings = {};
  // Configuraciones de la tabla de la modal
  settingsModal = {};
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    update: false,
    delete: false,
    detail: true,
  };
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Define cuando mostrar la tabla principal o el formulario de la modal
  formOpenModal = false;
  // Define si la serie en accion es para editar o agregar
  serieEdit = true;
  // Define si se muestra el control de fechas o no
  restart_date = false;
  // Define el consecutivo seleccionado para modificar o eliminar
  selectedConsecutive: any;
  // Define la serie, subserie y tipo documental para eliminar o modificar
  selectedSerieSubDoc: any;
  // Id del detalle seleccionado para eliminar o modificar
  detailId: number = 0;
  // Define la accion a realizar en el formulario
  actionForm = "";
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  controlsModal: BaseControl<any>[] = [];
  // Contiene los controles suprimidos cuando el checkbox es false
  controlsDeleted: BaseControl<any>[] = [];
  // Pregunta de la modal de confirmaciones
  question = "";
  // Lista de tipos de periodicidad
  list = ["Día", "Mes", "Año"];

  dependency: any[] = [];
  //modal
  modalRef: BsModalRef;
  // Series disponibles
  @Input() series: SeriePredeterminada[] = [];
  // Subseries disponibles
  @Input() subseries: any[] = [];
  // Lista de subseries a mostrar
  subseriesList: any[] = [];
  // Tipos documentales disponibles
  @Input() typeDocumentary: any[] = [];
  // Lista de detalles
  typeDocumentaryDetail: Consecutive;
  // Datos para llenar la tabla de la modal de detalle de consecutivo
  dataTableModal: Detalles[] =[];
  // Lista de tipos documentales
  typeDocumentaryList: any[] = [];
  // Controla el número del consecutivo
  consecutive: number = 0;
  // Id del consecutivo seleccionado para los detalles
  consecutiveId: number = 0;
  // Datos iniciales para la tabla
  dataTable: Consecutive[] = [];
  // id de la serie seleccionada
  idSerieSelect: any = null;
  // id de la subserie seleccionada
  idSubSerieSelect: any;
  // Id del tipo documental seleccionado
  idTypeDocumentary: any;
  // Referencia al componente de confirmación
  @ViewChild("confirm") private confirm: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild("ngSelect") ngSelectTpl: TemplateRef<any>;
  // Referencia a la plantilla del formulario de la modal
  @ViewChild("ngSelectModal") ngSelectModal: TemplateRef<any>;
  //Referencia al modal personalizado
  @ViewChild("modalDetail") modalDetail: any;
  //Referencia al modal de modificar o agregar
  @ViewChild("modalAddModify") modalAddModify: any;
  // Referencia al control de series
  @ViewChild("serieControl") serieControl: TemplateRef<any>;
  // Referencia al control de subseries
  @ViewChild("subserieControl") subserieControl: TemplateRef<any>;
  // Referencia al control de tipo documental
  @ViewChild("typeDocControl") typeDocControl: TemplateRef<any>;

  constructor(
    private as: AuthenticationService,
    private toastr: ToastrService,
    private cmfs: ConsecutiveManagementFormService,
    private modal: BsModalService,
    private cmds: ConsecutiveManagementDataService
  ) {}

  ngOnInit() {
    // Determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.created
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.update
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationDocument,
      Const.types_action_permissions.delete
    );
    this.activateAction.detail = true;
    // this.getTypeDocumentary();
    const configTable = new ConsecutiveManagementConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      // log.debug(res.action, res.data);
      this.defineActionCondictions(res.action, res.data);
    });
    //configuración de la tabla de la modal
    this.settingsModal = configTable.settingsModal;
    configTable.accionModal.subscribe((res: any) => {
      // log.debug(res.action, res.data);
      this.defineActionModal(res.action, res.data);
    });
    //Obtiene empresas y sedes
    this.getValuesDependency();

    // Obtiene los consecutivos disponibles
    this.getConsecutives();
  }



  /**
   *Actualiza la lista de tipos documentales
   *
   * @memberof ConsecutiveManagementComponent
   */
  updateTypesDocumentary(){
    this.typeDocumentaryList.length = 0;
    this.typeDocumentary.forEach(documentary =>{
      if(documentary.subserie.id == this.idSubSerieSelect){
        this.typeDocumentaryList = [...this.subseriesList, documentary];
      }
    });
  }

  /**
   *Actualiza la lista de subseries a mostrar
   *
   * @memberof ConsecutiveManagementComponent
   */
  updateSubseries() {
    this.subseriesList.length = 0
    this.subseries.forEach(subseries =>{
      if(subseries.serie.id == this.idSerieSelect){
        this.subseriesList = [...this.subseriesList, subseries];
      }
    });
  }

  /**
   *Obtiene los consecutivos
   *
   * @memberof ConsecutiveManagementComponent
   */
  getConsecutives() {
    this.cmds.getConsecutives().subscribe(async (res) => {
      if (res) {
        this.dataTable = await res;
        this.dataTable.forEach((data) => {
          data.fecha_reinicio = parseDate(data.fecha_reinicio);
          data["detail"] = false;
        });
        this.source = new LocalDataSource(this.dataTable);
      }
    });
  }
  
  async getValuesDependency(){
    this.dependency = [];
    await this.cmds.getCompanies().subscribe(async (data) => {
      if (data && data.length) {
        await this.cmds.getSedes(data[0].id).subscribe((data) => {
          if (data && data.length) {
            data.sort((a, b) => a.id - b.id);
            data.forEach((rol) => {
              this.dependency.push({
                value: rol.id,
                key: rol.nombre,
              });
            });
          }
        });
      }
    });
  }

  /**
   *Obtiene las series disponibles
   *
   * @memberof ConsecutiveManagementComponent
   */
  getSeries() {
    this.cmds.getSeriesDocumentary().subscribe(series => {
      this.series = series;
    });
  }

  /**
   * Obtener un tipo documental
   *
   * @memberof DocumentsComponent
   */
  getTypeDocumentary(id: number) {
    this.cmds.getConsecutiveDetails(id).subscribe(async data => {
      if(data){
        this.typeDocumentaryDetail = await data;
        this.dataTableModal = await this.typeDocumentaryDetail.detalle;
        this.sourceModal = new LocalDataSource(this.dataTableModal);
      }
    });
  }

  /**
   * Condiciona acción a realzar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof ConsecutiveManagementComponent
   */
  async defineActionCondictions(action: "add" | "update" | "detail" | "delete" = "add", data?: any) {
    switch (action) {
      case "add":
        if (this.activateAction.created) {
          this.formOpen = true;
          this.serieEdit = false;
          this.formOpenModal = false;
          this.actionForm = "Agregar";
          if (this.dataTable.length !== 0) {
            this.consecutive = 0;
          }
          this.controls = this.getControlsFormBasic({
            dataTypeahead: [],
            ngSelectTpl: this.ngSelectTpl,
            consecutive: this.consecutive,
            dependency: this.dependency,
            list: this.list
          });
        } else {
          this.toastr.error("Usted no posee permisos para agregar consecutivos al sistema", "Permiso denegado");
        }
        break;
      case "update":
        if (this.activateAction.update) {
          this.formOpen = true;
          this.formOpenModal = false;
          this.serieEdit = true;
          this.actionForm = "Modificar";
          this.controls = this.getControlsFormBasic({
            dataTypeahead: [],
            ngSelectTpl: this.ngSelectTpl,
            dependency: this.dependency,
            list: this.list,
            data,
          });
          if (data.dependencia) {
            let rowDependency =  find( this.controls, { key : 'dependencia'});
            if (rowDependency) {
              rowDependency.value = data.dependencia.id;
            }
          }
          this.selectedConsecutive = data;
        } else {
          this.toastr.error("Usted no posee permisos para modificar los consecutivos del sistema", "Permiso denegado");
        }
        break;
      case "delete":
        if (this.activateAction.delete) {
          this.selectedConsecutive = data;
          this.question = "¿Realmente desea eliminar el consecutivo?";
          this.confirm.open();
        } else {
          this.toastr.error("Usted no posee permisos para eliminar consecutivos del sistema", "Permiso denegado");
        }
        break;
      case "detail":
        if (this.activateAction.detail) {
          this.formOpen = false;
          this.formOpenModal = true;
          this.consecutive = data.consecutivo
          this.consecutiveId = data.id
          this.getTypeDocumentary(this.consecutiveId);
          this.modalRef = this.modal.show(this.modalDetail, {
            class: "modal-lg-personalized",
            ignoreBackdropClick: true,
          });
        } else {
          this.toastr.error("Usted no posee permisos para ver el detalle del consecutivo", "Permiso denegado");
        }
        break;
    }
  }

  /**
   * Condiciona acción a realzar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof ConsecutiveManagementComponent
   */
  async defineActionModal(action: "add" | "update" | "delete" = "add", data?: any) {
    switch (action) {
      case "add":
        if (this.activateAction.created) {
          this.formOpen = false;
          this.serieEdit = false;
          this.actionForm = "Agregar";
          this.controlsModal = await this.getSerieSubDocForm({
            dataTypeahead: [],
            serieTmplt: this.serieControl,
            subserieTmpl: this.subserieControl,
            typeDocTmpl: this.typeDocControl,
          });
          this.openAddModal();
        } else {
          this.toastr.error("Usted no posee permisos para agregar consecutivos al sistema", "Permiso denegado");
        }
        break;
      case "update":
        if (this.activateAction.update) {
          this.formOpen = false;
          this.serieEdit = false;
          this.actionForm = "Modificar";
          this.selectedSerieSubDoc = data;
          this.detailId = data.id;
          this.formatSelectors(data.id_serie, data.id_subserie, data.id_tipo_documental);
          this.controlsModal = await this.getSerieSubDocForm({
            dataTypeahead: [],
            serieTmplt: this.serieControl,
            subserieTmpl: this.subserieControl,
            typeDocTmpl: this.typeDocControl,
            data,
          });
          this.openAddModal();
        } else {
          this.toastr.error("Usted no posee permisos para modificar los consecutivos del sistema", "Permiso denegado");
        }
        break;
      case "delete":
        if (this.activateAction.delete) {
          this.selectedSerieSubDoc = data;
          this.detailId = data.id
          this.question = "¿Realmente desea eliminar la serie, subserie y tipo documental?";
          this.confirm.open();
        } else {
          this.toastr.error("Usted no posee permisos para eliminar consecutivos del sistema", "Permiso denegado");
        }
        break;
    }
  }

  /**
   *Método que llena los selectores cuando hay una edición
   *Solo funciona en este caso específico
   *
   * @param {number} idSerie
   * @param {number} [idSubserie]
   * @param {number} [idDocumentary]
   * @memberof ConsecutiveManagementComponent
   */
  formatSelectors(idSerie: number, idSubserie?: number, idDocumentary?: number){
    this.subseriesList.length = 0
    this.subseriesList = [...this.subseriesList];
    this.typeDocumentaryList.length = 0;
    this.typeDocumentaryList = [...this.typeDocumentaryList];
    this.subseries.forEach(subseries =>{
      if(subseries.serie.id == idSerie){
        this.subseriesList = [...this.subseriesList, subseries];
      }
    });
    if(idSubserie){
      this.typeDocumentaryList.length = 0
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.idSubSerieSelect = idSubserie;
      this.typeDocumentary.forEach(documentary =>{
        if(documentary.subserie.id == this.idSubSerieSelect){
          this.typeDocumentaryList = [...this.typeDocumentaryList, documentary];
        }
      });
    }
    if(idDocumentary){
      this.idTypeDocumentary = idDocumentary;
    }
  }

  /**
   * Retorna los controles del formulario.
   *
   * @param {*} [objectModel]
   * @returns {BaseControl<any>[]}
   * @memberof ConsecutiveManagementComponent
   */
  getControlsFormBasic(objectModel?: any): BaseControl<any>[] {
    return objectModel ? this.cmfs.getFormConsecutive(objectModel) : this.cmfs.getFormConsecutive();
  }

  /**
   * Retorna los controles del formulario.
   *
   * @param {*} [objectModel]
   * @returns {BaseControl<any>[]}
   * @memberof ConsecutiveManagementComponent
   */
  getSerieSubDocForm(objectModel?: any): BaseControl<any>[] {
    return objectModel ? this.cmfs.getFormModal(objectModel) : this.cmfs.getFormModal();
  }

  /**
   * Cierra la vista del formulario de creación o edición de una serie
   *
   * @memberof ConsecutiveManagementComponent
   */
  closeFormSerie() {
    this.actionForm = "";
    this.question = "";
    this.formOpen = false;
    this.serieEdit = false;
  }

  openAddModal() {
    this.modalRef.hide();
    this.modalRef = this.modal.show(this.modalAddModify, { class: "modal-lg-personalized", ignoreBackdropClick: true });
  }

  closeModalAddModify() {
    this.formOpen = false;
    this.serieEdit = false;
    this.idSerieSelect = null;
    this.idSubSerieSelect = null;
    this.idTypeDocumentary = null;
    this.selectedSerieSubDoc = null;
    this.subseriesList.length = 0;
    this.typeDocumentaryList.length = 0;
    this.modalRef.hide();
    this.modalRef = this.modal.show(this.modalDetail, { class: "modal-lg-personalized", ignoreBackdropClick: true });
  }

  /**
   * Guarda o edita un tipo de documental en el sistema
   *
   * @param {*} data
   * @memberof TypeDocumentaryComponent
   */
  sended(data: any) {
    let consecutivo = {
      consecutivo: data.consecutivo,
      dependencia: data.dependencia,
      periodicidad: data.dpicker2,
      tipo_periodicidad: data.ngSelect,
      fecha_reinicio: data.dpicker3,
      reinicio: data.reinicio,
    };
    if (this.selectedConsecutive) {
      this.cmds.updtaeConsecutive(this.selectedConsecutive.id, consecutivo).then(result =>{
        if(result){
          this.getConsecutives();
        }
      });
    } else {
      this.cmds.addConsecutive(consecutivo).then((res) => {
        if (res) {
          this.getConsecutives();
        }
      });
    }
    this.formOpen = false;
    this.serieEdit = false;
    this.selectedConsecutive = null;
  }

  updateSaveConsecutive(data: any) {
    let serieSubDoc = {
      consecutivo: this.consecutiveId,
      serie: data.serie,
      subserie: data.subserie,
      tipo_documental: data.tipo_documental,
    };
    if (this.selectedSerieSubDoc) {
      this.cmds.updateDetailConsecutive(this.detailId,serieSubDoc).then(result => {
        if(result){
          this.getTypeDocumentary(this.consecutiveId);
        }
      });
    } else {
      this.cmds.addDetailConsecutive(serieSubDoc).then(result => {
        if(result){
          this.getTypeDocumentary(this.consecutiveId);
        }
      });
    }
    this.closeModalAddModify();
  }

  /**
   *Obtiene los cambios realizados en el formulario de agregar/modificar
   *
   * @param {*} data
   * @memberof ConsecutiveManagementComponent
   */
  changeForm(data: any, type: string) {
    if(type=="serie" && data !== undefined){
      this.subseriesList.length = 0
      this.subseriesList = [...this.subseriesList];
      this.typeDocumentaryList.length = 0;
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.subseries.forEach(subseries =>{
        if(subseries.serie.id == data.id){
          this.subseriesList = [...this.subseriesList, subseries];
        }
      });
      this.idSubSerieSelect = null;
      this.idTypeDocumentary = null;
    }else if(type=="serie" && data == undefined) {
      this.subseriesList.length = 0;
      this.subseriesList = [...this.subseriesList];
      this.typeDocumentaryList.length = 0;
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.idSubSerieSelect = null;
      this.idTypeDocumentary = null;
    }

    if(type=="subserie" && data !== undefined){
      this.typeDocumentaryList.length = 0
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.idTypeDocumentary = null;
      this.typeDocumentary.forEach(documentary =>{
        if(documentary.subserie.id == this.idSubSerieSelect){
          this.typeDocumentaryList = [...this.typeDocumentaryList, documentary];
        }
      });
    }else if(type=="subserie" && data == undefined) {
      this.typeDocumentaryList.length = 0;
      this.typeDocumentaryList = [...this.typeDocumentaryList];
      this.idTypeDocumentary = null;
    }
  }

  /**
   *Cierra la modal de detalles
   *
   * @memberof ConsecutiveManagementComponent
   */
  closeModal() {
    this.modalRef.hide();
  }

  actionComfirm(res: boolean) {
    if (res) {
      if (this.selectedConsecutive) {
        this.cmds.deleteConsecutive(this.selectedConsecutive.id).then(res=>{
          if(res){
            this.getConsecutives();
          }
        })
        this.selectedConsecutive = null;
      } else if (this.selectedSerieSubDoc) {
        this.cmds.deleteDetails(this.detailId).then(res=>{
          if(res){
            this.getTypeDocumentary(this.consecutiveId);
          }
        })
        this.selectedSerieSubDoc = null;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/documents/consecutive-management/consecutive-management.component.ts